import { useMemo } from "react";

import { SubscriberController } from "../../../../services/controllers/subscription";

import { Alert } from "../../../../components/ui/Alert";

export function AlertPixCode() {
  const CSubscriber = SubscriberController();

  const alert = Alert.store(st => st.data.alerts[CSubscriber.pixCodeAlertName])
  const pix = useMemo(() => CSubscriber.selectedTransaction?.payment?.pix, [alert?.open])

  return (
    <Alert.Root name={CSubscriber.pixCodeAlertName}>
      <Alert.Content>
        <Alert.Title>Pagamento com Pix</Alert.Title>
        <Alert.Description>
          <span className="text-center">Para pagar, escaneie o QR Code, ou copie o código abaixo.</span>
        </Alert.Description>

        <div className="w-full flex flex-col items-center gap-10  my-4 px-4">
          <img src={pix?.qrcodePath} alt="QR Code Pix" className="w-64 h-64 object-contain" />
          <p className="w-full break-all text-center select-all cursor-text">{pix?.code}</p>
        </div>

        <Alert.Actions className="!mt-4">
          <Alert.Cancel>Fechar</Alert.Cancel>
        </Alert.Actions>
      </Alert.Content>
    </Alert.Root>
  )
}
